import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ControlsModule } from "src/app/controls/controls.module";
import { SharedModule } from "src/app/shared/shared.module";
import { EditLearnsetComponent } from "./edit-learnset.component";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  declarations: [
    EditLearnsetComponent
  ],
  imports: [
    CommonModule,
    ControlsModule,
    SharedModule,
    TranslateModule
  ],
  exports: [
    EditLearnsetComponent
  ]
})
export class EditLearnsetModule { }